export class ProdutoListaRequest {
  produtoIdsList?: number[];
  searchText?: string;
  idProdutoListaRefinamento: number;
  idCategoria?: number;
  idFornecedor?: number;
  idMarca?: number;
  ncm?: string;
  isSemNcm?: boolean;
  listIdTag?: number[];
  listIdTipoProduto?: number[];
  isAtivo?: boolean;
}